import React from 'react';
import StatsDashboard from '@/components/Stats/StatsDashboard';

const StatsDashboardPage = () => <StatsDashboard />;

export default StatsDashboardPage;
